module.exports = __webpack_public_path__ + "img/ankr.bb97292d.svg";